<template>
  <div class="m-ip-search">
    <input
      :type="ipType"
      ref="searchIp"
      class="m-ip-search__ip"
      :placeholder="placeholder"
      @keyup.enter="goToDetailPage()"
    />
    <button
      type="button"
      class="m-ip-search__btn m-icon-24 m-icon-24--dark m-icon-24--arrow-right"
      @click="goToDetailPage()"
    ></button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "IpSearch",
  props: {
    placeholder: {
      type: String,
      required: false,
    },
    ipType: {
      type: String,
      default: "text",
    },
  },
  methods: {
    goToDetailPage() {
      const searchValue = this.$refs.searchIp.value;

      if (!searchValue) {
        return;
      }

      let url = `/view/${searchValue}/`;

      // development env
      if (process.env.NODE_ENV && process.env.NODE_ENV === "development") {
        url = `http://${location.hostname}:8000${url}`;
        location.href = url;
        return;
      }

      axios
        .head(url)
        .then(() => {
          location.href = url;
        })
        .catch(() => {
          alert("Not found!");
        });
    },
  },
};
</script>
